import { Component, OnInit, Input } from '@angular/core';
import { ShareDataService } from 'src/app/_services/ShareData.service';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { ActionType } from 'src/app/_models/ActionType.enum';
import { DataSource } from 'src/app/_models/DataSource';
import { ViewSource } from 'src/app/_models/ViewSource';

@Component({
  selector: 'app-emailTemplates',
  templateUrl: './emailTemplates.component.html',
  styleUrls: ['./emailTemplates.component.css']
})
export class EmailTemplatesComponent implements OnInit {

  @Input() currentApiKey: any;
  selectedData: any;
  templates: any;
  emailConfigSelected:any;
  
  constructor(private _shareData: ShareDataService, private _adminService: AdminServiceService, private _alertify: AlertifyService) { 
  }

  ngOnInit() {
    this._shareData.currentDataSource.subscribe(data => {
      
      if (!data || data.id != this.currentApiKey)
        return;

      if (data.key == 'emailtemplates')
        this.loadTemplates(data);

      if (data.key == 'emailtemplate' && data.action == ActionType.Updated) {
        let found = this.templates.find(t => t.id == data.value.Id);
        if (found) {
          found.title = data.value.Title;
          found.code = data.value.Code;
          found.shortDescription = data.value.ShortDescription;  
          found.content = data.value.Content;
        }
      }

      if (data.key == 'emailtemplate' && data.action == ActionType.Added) {

        if (!this.templates)
          this.templates = new Array<any>();

        this.templates.push({
          id: data.value.id,
          title: data.value.Title,
          code: data.value.Code,
          shortDescription: data.value.ShortDescription,
          content: data.value.Content
        });

      }


    });
  }

  onAddNewTemplate() {
    this._shareData.notifyCurrentApiKey(this.currentApiKey);
    this.notifyAction(null, ActionType.Add, "emailtemplate", null);    
  }

  onEditEmailTemplate(template) {
    this._shareData.notifyCurrentApiKey(this.currentApiKey);
    this.notifyAction(template.id, ActionType.Edit, "emailtemplate", template);

  }

  onBackToEmailConfigurations() {
    this._shareData.notifyCurrentView(new ViewSource(this.currentApiKey, "emailconfigurations"));
  }

  loadTemplates(dataSelected) {

    this.emailConfigSelected = dataSelected.value;
  
    this._adminService.getEmailTemplates(this.currentApiKey, dataSelected.value.id).subscribe(data => {
      this.templates = data;
    }, error => {
      this._alertify.error(error);
    })

  }

  private notifyAction(id: any, action: ActionType, key: string,  value: any) {
    this._shareData.notifyCurrentDataSource(new DataSource(id, action, key, value ));
  }  

}
